import { render, staticRenderFns } from "./question-component2.vue?vue&type=template&id=13c5d682&scoped=true&"
import script from "./question-component2.vue?vue&type=script&lang=ts&"
export * from "./question-component2.vue?vue&type=script&lang=ts&"
import style0 from "./question-component2.vue?vue&type=style&index=0&id=13c5d682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5d682",
  null
  
)

export default component.exports